import {makeAutoObservable} from 'mobx'
import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect} from 'react'
import {UIElement} from '../model/ui-element'
import {ApiElement} from './api-element'

export interface ApiTaskInfoParams {
  element: UIElement
}

const refEl: {el?: UIElement} = {
  el: undefined
}

export const ApiTaskInfoCtl = {
  setEl: (params: ApiTaskInfoParams) => {
    refEl.el = params.element
    uiStore.updateModified()
  }
}

export const ApiTaskInfo = observer(() => {
  useEffect(() => {
    //
  }, [uiStore.state.modified])

  if (!refEl.el) {
    return null
  }

  return (
    <div className={'api-task-info'}>{<ApiElement element={refEl.el} />}</div>
  )
})

///

class UIStore {
  state: {modified: number} = {
    modified: 0
  }

  constructor() {
    makeAutoObservable(this, {}, {autoBind: true})
  }

  updateModified(): void {
    this.state.modified = Date.now()
  }
}

const uiStore = new UIStore()
